import moment from 'moment';
import { PersistentRepo } from '_src/shared/repo';

const noteType = {
  attendance_archived: 'Attendance Archived',
  attendance_deleted: 'Attendance Deleted',
  test_deleted: 'Test Deleted',
  test_archived: 'Test Archived'
};

const transform = res => {
  const getTimezone = PersistentRepo.get('getTimezone');

  const data = res?.data?.studentReport?.clockinResult || [];

  const transformedData = data.map(item => {
    return {
      ...item,
      testDeletedDate: item.testDeletedDate ?? 'N/A',
      deleter: item.deleter ?? 'N/A',
      note: noteType[item.note] ?? 'N/A',
      attendanceDeletedDate: item.attendanceDeletedDate
        ? moment
            .tz(
              moment.parseZone(moment(item.attendanceDeletedDate)).format('MM/DD/YYYY HH:mm'),
              'MM/DD/YYYY HH:mm',
              getTimezone
            )
            .format('MM/DD/YYYY HH:mm')
        : 'N/A',
      attendanceArchivedDate: item.attendanceArchivedDate
        ? moment
            .tz(
              moment.parseZone(moment(item.attendanceArchivedDate)).format('MM/DD/YYYY HH:mm'),
              'MM/DD/YYYY HH:mm',
              getTimezone
            )
            .format('MM/DD/YYYY HH:mm')
        : 'N/A',
      testDeletedDate: item.testDeletedDate
        ? moment
            .tz(
              moment.parseZone(moment(item.testDeletedDate)).format('MM/DD/YYYY HH:mm'),
              'MM/DD/YYYY HH:mm',
              getTimezone
            )
            .format('MM/DD/YYYY HH:mm')
        : 'N/A',
      testArchivedDate: item.testArchivedDate
        ? moment
            .tz(
              moment.parseZone(moment(item.testArchivedDate)).format('MM/DD/YYYY HH:mm'),
              'MM/DD/YYYY HH:mm',
              getTimezone
            )
            .format('MM/DD/YYYY HH:mm')
        : 'N/A',
      deleter: (item.deleter || '').trim().length > 0 ? item.deleter : 'N/A',
      testType: (item.testType || '').trim().length > 0 ? item.testType : 'N/A',
      programType: (item.programType || '').trim().length > 0 ? item.programType : 'N/A'
    };
  });

  return { data: transformedData, total: res?.data?.studentReport?.totalNr };
};

export { transform };
